module.exports = __webpack_public_path__ + "static/img/csLogo.d22547d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/csLogo.png
// module id = 6l5z
// module chunks = 2